<div class="chat-traveller" [class.chat-traveller--locked]="locked">
  <div class="chat-traveller__title">{{ title }}</div>

  @if (prompt.travellers.length) {
    <ul class="chat-traveller__list">
      @for (row of prompt.travellers; track $index) {
        <li class="chat-traveller__row">
          <span class="chat-traveller__avatar" aria-hidden="true">{{ initials(row) }}</span>
          <span class="chat-traveller__text">
            <span class="chat-traveller__name">{{ row.name }}</span>
            @if (row.detail) {
              <span class="chat-traveller__detail">{{ row.detail }}</span>
            }
          </span>
          @if (row.lead) {
            <span class="chat-traveller__badge" i18n="@@chatTravellerLeadBadge">Lead</span>
          }
          @if (row.guest) {
            <span
              class="chat-traveller__badge chat-traveller__badge--guest"
              i18n="@@chatTravellerGuestBadge"
              >Guest</span
            >
          }
        </li>
      }
    </ul>
  }

  @if (prompt.note) {
    <div class="chat-traveller__note">{{ prompt.note }}</div>
  }

  @if (prompt.chips.length) {
    <div class="chat-traveller__chips">
      @for (label of prompt.chips; track $index) {
        <button
          type="button"
          class="chat-traveller__chip"
          [disabled]="locked"
          (click)="onChip(label)"
        >
          {{ label }}
        </button>
      }
    </div>
  }
</div>
